import { io } from 'socket.io-client';
import { generateUrl } from '../utils/envDynamicValues';
import { runtimeEnv } from '../config/runtimeEnv';

export const socket = io(runtimeEnv.apiBaseUrl ?? generateUrl('api'), {
  path: '/sportsbook-feed-api/socket.io',
  transports: ['websocket', 'polling'],
  autoConnect: false,
});
